<template>
  <div>
    <div class="ui form" v-if="voided.response_data">
      <div class="ui dividing small header">
        {{ $t("transaction void response") }}
        <small
          >| {{ $t("date") }}
          {{
            voided.create_date
              | formatDate(enterprise_setup.detailed_date_format)
          }}</small
        >
      </div>
      <div class="five fields">
        <div class="field">
          <label for="">{{ $t("audit number") }}</label>
          <input
            type="text"
            v-model="voided.response_data.result.response.auditNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("reference number") }}</label>
          <input
            type="text"
            v-model="voided.response_data.result.response.referenceNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("authorization number") }}</label>
          <input
            type="text"
            v-model="voided.response_data.result.response.authorizationNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("response code") }}</label>
          <input
            type="text"
            v-model="voided.response_data.result.response.responseCode"
          />
          <div class="field"></div>
        </div>
        <div class="field">
          <label for="">{{ $t("message type") }}</label>
          <input
            type="text"
            v-model="voided.response_data.result.response.messageType"
          />
          <div class="field"></div>
        </div>
      </div>
      <invoice
        :requestData="data"
        :dataIn="voided"
        :transaction="transaction"
      />
    </div>
  </div>
</template>

<script>
import filters from "@/filters";
import { enterprise_setup } from "@/utils";
import { translate_status, translate_type } from "../local_translator";
import { cloneDeep } from "lodash";
import Invoice from "./VoidInvoice.vue";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "VisaPaymentTransactionModalVoid",
  filters: filters,
  components: { Invoice },
  computed: {
    enterprise_setup() {
      let x = enterprise_setup(this);
      return x;
    },
  },
  props: { transaction: Object },
  data() {
    return {
      voided: {},
      data: {
        card_name: "",
        card_number: "",
        expire_date: "",
        cvv: "",
        amount: "",
        quotas: 1,
      },
      payment_response: {},
    };
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      let vm = this;
      if (
        vm.transaction &&
        vm.transaction.vis_voids &&
        vm.transaction.vis_voids.length
      ) {
        let clone = cloneDeep(vm.transaction.vis_voids[0]);
        clone.request_data = JSON.parse(clone.request_data);
        clone.response_data = JSON.parse(clone.response_data);
        this.voided = clone;
      }
    }, 1000);
  },
  watch: {},
  updated: function() {},
};
</script>
